export default "__VITE_ASSET__2ad90201__"